import axiosInstance from "@/api/axiosInstance";
import {
  GetEnrollmentBillingRequest,
  GetEnrollmentBillingResponse,
} from "./types";

export const getEnrollmentBilling = async (
  requestData: GetEnrollmentBillingRequest,
): Promise<GetEnrollmentBillingResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/enrollment-billing`;

  const response =
    await axiosInstance.get<GetEnrollmentBillingResponse>(url);

  return response.data;
};
